export const MAX_MOBILE_WIDTH = 1024
